import React from 'react';
import { Section } from './ui/Section';
import { CheckIcon } from 'lucide-react';
export function WhatsIncluded() {
  return <Section background="gray" data-id="element-162">
      <div className="text-center mb-8" data-id="element-163">
        <h2 className="text-2xl font-bold text-[#111827]" data-id="element-164">
          ¿Qué viene en la caja?
        </h2>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8 max-w-lg mx-auto" data-id="element-165">
        <ul className="space-y-4" data-id="element-166">
          <li className="flex items-center" data-id="element-167">
            <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-168">
              <CheckIcon className="w-4 h-4 text-[#16A34A]" data-id="element-169" />
            </div>
            <span className="text-[#111827] font-medium" data-id="element-170">
              1x Proyector de Estrellas 360°
            </span>
          </li>
          <li className="flex items-center" data-id="element-171">
            <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-172">
              <CheckIcon className="w-4 h-4 text-[#16A34A]" data-id="element-173" />
            </div>
            <span className="text-[#111827] font-medium" data-id="element-174">
              1x Cable de alimentación USB
            </span>
          </li>
          <li className="flex items-center" data-id="element-175">
            <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-176">
              <CheckIcon className="w-4 h-4 text-[#16A34A]" data-id="element-177" />
            </div>
            <span className="text-[#111827] font-medium" data-id="element-178">1x Manual de uso</span>
          </li>
        </ul>
        <div className="mt-6 pt-6 border-t border-gray-100 text-center" data-id="element-179">
          <p className="text-sm text-[#4B5563] italic" data-id="element-180">
            * No incluye adaptador de pared ni pilas AA.
          </p>
        </div>
      </div>
    </Section>;
}